export default __webpack_public_path__ + "static/signpainter-housescript-74dacb40b4acbda2abe57de592050627.woff2";